import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { withSnackbar } from "notistack";
import { URL_BASE, ID_INSTITUCION, DEFTKN, DEFTKNCCEPO } from "../../constants";

const token = ID_INSTITUCION === 3 ? DEFTKNCCEPO : DEFTKN;

const ZERO = 0;
class PagoConektaCard extends Component {
  constructor(...props) {
    super(...props);
    this.state = {
      urlPago: "",
      error: null,
    };
  }

  loguedIn() {
    return !!localStorage.getItem("usr");
  }

  getConektaObj(
    accountId,
    idPersona,
    amount,
    concept,
    name,
    email,
    phone,
    level,
    carrer,
    campus
  ) {
    if (amount > 10000) {
      this.props.enqueueSnackbar("El monto no puede ser mayor a $10,000 MXN.", {
        variant: "error",
        autoHideDuration: 10000,
      });
      return; // Evita que se realice la solicitud
    }

    //let query = `"action":"generacargo","idCuenta":${accountId},"tipoPago":"paymentlink","cantidad":${amount}`;
    let query = `"action":"generacargo","idCuenta":0,"tipoPago":"paymentlink","cantidad":${amount},"idPersona":${idPersona},"privateKey":"key_qJHt9dhxgNSA8hvbzaxApt2"`;

    if (!this.loguedIn()) {
      query += `,"concepto":"${concept}","nombrePersona":"${name}","email":"${email}","telefono":"${phone}","nivelAcademico":"${level}","carrera":"${carrer}","campus":"${campus}"`;
    }

    fetch(`${URL_BASE}api/conekta?jsonParameters={${query}}`, {
      method: "post",
      headers: {
        Authorization: `Bearer ${
          accountId !== -1 ? localStorage.getItem("tkn") : token
        }`,
        Accept: "*/*",
        "Cache-Control": "no-cache",
        Host: "campusvirtualapi.azurewebsites.net",
        "Accept-Encoding": "gzip, deflate",
        Connection: "keep-alive",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          this.props.enqueueSnackbar(
            "No se pudo obtener la referencia en este momento, intentalo más tarde.",
            { variant: "warning", autoHideDuration: 10000 }
          );
        }
        response.json().then((res) => {
          if (typeof res == "string") {
            this.props.enqueueSnackbar(res, {
              variant: "error",
              autoHideDuration: 10000,
            });
            throw res;
          } else if (res.id !== undefined) {
            console.log(res);
            this.setState({
              urlPago: "https://pay.conekta.com/link/" + res.id,
            });
          }
        });
      })
      .catch((err) => {
        if (typeof err === "object") {
          const message500 =
            "Hubo un error en el servidor, intentalo más tarde.";
          this.props.enqueueSnackbar(message500, { variant: "warning" });
        } else if (typeof err === "string") {
          this.props.enqueueSnackbar(err, { variant: "warning" });
        }
        console.log("err:", err);
        throw err;
      });
  }

  componentDidMount() {
    this.getConektaObj(
      this.props.idCuenta,
      this.props.idPersona,
      this.props.amount,
      this.props.concept,
      this.props.name,
      this.props.email,
      this.props.phone,
      this.props.level,
      this.props.carrer,
      this.props.campus
    );
  }

  render() {
    return (
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Confirmación de pago
          </Typography>

          <Typography variant="body1">
            <b>Nombre:</b> {this.props.name}
          </Typography>
          <Typography variant="body1">
            <b>Concepto:</b> {this.props.concept}
          </Typography>
          <Typography variant="body1">
            <b>Monto:</b> ${this.props.amount} MXN
          </Typography>
          {this.state.error && (
            <Typography variant="body2" color="error" style={{ marginTop: 16 }}>
              {this.state.error}
            </Typography>
          )}
        </CardContent>

        <CardActions style={{ justifyContent: "center" }}>
          {this.state.urlPago && (
            <Button
              variant="contained"
              color="primary"
              href={this.state.urlPago}
              target="_blank"
              rel="noopener noreferrer"
            >
              Ir a pagar con tarjeta
            </Button>
          )}
        </CardActions>
      </Card>
    );
  }
}

export default withSnackbar(PagoConektaCard);
